import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class LayoutService {
  private menuToggleSubject = new Subject<void>();
  private menuCloseSubject = new Subject<void>();

  menuToggle$ = this.menuToggleSubject.asObservable();
  menuClose$ = this.menuCloseSubject.asObservable();

  toggleMenu() {
    this.menuToggleSubject.next();
  }

  closeMenu() {
    this.menuCloseSubject.next();
  }
}
